import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Parallax from "./animations/Parallax";
import ScrollReveal from "./animations/ScrollReveal";
import Header from "./components/Header";
import LazyVideos from "./components/LazyVideos";
import AutoplayVideos from "./components/AutoplayVideos";
import HomeHeroTitles from "./components/HomeHeroTitles";
import Popup from "./components/Popup";
import SmoothScroll from "./singleton/SmoothScroll";
import WindowSize from "./singleton/WindowSize";

gsap.registerPlugin(ScrollTrigger);

class Website {
	$body: JQuery<HTMLElement>;
	$links: JQuery<HTMLElement>;
	header: Header;
	smoothScroll: typeof SmoothScroll;
	windowSize: WindowSize;

	constructor() {
		this.$body = $("body");
		this.$links = $("a");
		this.header = new Header();

		// Activate the smooth scrolling feature.
		this.smoothScroll = SmoothScroll;
		this.windowSize = WindowSize.getInstance();

		this.initObservers();
		this.initScrollingLinks();
		this.initParallax();
		void this.initEmbla();
		this.initPopup();
	}

	initScrollingLinks() {
		this.$links.on("click", this.linkClicked.bind(this));
		this.scrollOnPageLoad();
	}

	linkClicked(e: JQuery.ClickEvent) {
		const $cur = $(e.currentTarget);
		const href = $cur.attr("href");
		if (!href) return;
		const hrefArr = href.split("#");
		const { pathname, origin, host } = window.location;

		// If the href is empty or just a hash, or if it's not a hash but the
		// path doesn't match the current page, do nothing.
		if (
			!href ||
			href === "#" ||
			(!href.startsWith("#") && !href.includes("#")) ||
			(!href.startsWith("#") &&
				hrefArr[0] !== pathname &&
				hrefArr[0] !== origin + pathname &&
				hrefArr[0] !== `//${host}${pathname}`)
		) {
			return;
		}

		const $target = href.startsWith("#") ? $(href) : $(`#${hrefArr[1]}`);
		if ($target.length) {
			e.preventDefault();

			if (this.header.headerIsOpened) {
				this.header.closeNav();
			}

			this.smoothScroll.scrollToSection($target);

			// update url hash
			// window.history.pushState(null, '', href);
		}
	}

	scrollOnPageLoad() {
		const { hash } = window.location;

		if (!hash || hash === "#") return;
		const $target = $(hash);
		if (!$target.length) return;

		setTimeout(() => {
			this.smoothScroll.scrollToSection($target);
		}, 200);
	}

	initObservers() {
		// Pick hero title before reveal so the final text is animated.
		new HomeHeroTitles();
		new ScrollReveal(
			$(
				"[data-visibility]:not([data-is-visible]), [data-visibility-inside]>*:not([data-is-visible])",
			),
		);
		new LazyVideos();
		new AutoplayVideos();
	}


	initParallax() {
		const $parallax = $("[data-parallax-container]");
		if (!$parallax.length) return;

		$parallax.each((_, el) => {
			const $el = $(el);
			if (!$el.length) return;

			new Parallax($el.get(0)!);
		});
	}

	async initEmbla() {
		const $carousels = $(".embla");
		if (!$carousels.length) return;

		const { default: initEmblaCarousels } = await import(
			"./components/EmblaCarousel"
		);
		initEmblaCarousels();
	}

	initPopup() {
		const $popup = $("[data-popup]");
		if (!$popup.length) return;

		const el = $popup.get(0);
		if (!el) return;

		new Popup(el);
	}
}

$(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const _website = new Website();
});
